import { bookingCancel } from './bookingCancel';
import { bookingResponse } from './bookingResponse';
import { chatOpen } from './chatOpen';
import { checkoutForm } from './checkoutForm';
import { checkoutResponse } from './checkoutResponse';
import { coreReady } from './coreReady';
import { externalTwin } from './externalTwin';
import { logged } from './logged';
import { ratesAddToCart } from './ratesAddToCart';
import { ratesResponse } from './ratesResponse';

export const ProviderAnalytics = {
  bookingCancel,
  bookingResponse,
  chatOpen,
  checkoutForm,
  checkoutResponse,
  coreReady,
  externalTwin,
  logged,
  ratesAddToCart,
  ratesResponse,
};
